import analyze from './fa/Analyze'
import Auth from './fa/Auth'
import Bills from './fa/Bills'
import bot from './fa/Bot'
import Categories from './fa/Categories'
import collections from './fa/Collections'
import Comments from './fa/Comments'
import Dashboard from './fa/Dashboard'
import LoginNotice from './fa/LoginNotice'
import Logs from './fa/Logs'
import Packages from './fa/Packages'
import Payments from './fa/Payments'
import Products from './fa/Products'
import Reports from './fa/Reports'
import Settings from './fa/Settings'
import SiteBuilder from './fa/SiteBuilder'
import Support from './fa/Support'
import TelegramBot from './fa/TelegramBot'
import Tickets from './fa/Tickets'
import users from './fa/Users'

export default {
  AppName: 'انارگیفت',
  LoginButton: 'ورود به پنل',
  SendCodeButton: 'ارسال کد ورود',
  Code: 'کد ورود',
  CheckCodeButton: 'تایید کد',
  Mobile: 'شماره‌همراه',
  Password: 'کلمه عبور',
  Email: 'ایمیل',
  Num: 'شماره',
  List: 'لیست',
  Preview: 'نمایش',
  Edit: 'ویرایش',
  Confirm: 'تایید',
  Reject: 'رد کردن',
  Add: 'افزودن',
  Create: 'ایجاد',
  Delete: 'حذف',
  DeleteAll: 'حذف همه',
  Show: 'مشاهده',
  Update: 'بروزسانی',
  Date: 'تاریخ',
  User: 'کاربر',
  Row: 'ردیف',
  Send: 'ارسال',
  Pages: 'صفحات',
  Error: 'خطا',
  Price: 'قیمت',
  FAQ: 'پرس و پاسخ',
  Select: 'انتخاب',
  NotSelect: 'بدون انتخاب',
  Search: 'جستجو',
  Filter: 'فیلتر',
  Filters: 'فیلتر ها',
  Dollar: 'دلار',
  RemoveFilters: 'حذف فیلتر ها',
  Reports: 'گزارش ها',
  Excel: 'اکسل',
  Categories: 'دسته بندی ها',
  Category: 'دسته بندی',
  SelectCat: 'انتخاب نوع دسته',
  NoApiConnection: 'ارتباط با api قطع شده است لطفا بررسی کنید.',
  CatNameEng: 'نام انگلیسی دسته بندی',
  EducationalLink: 'لینک آموزش استفاده',
  CatName: 'نام دسته',
  CatPageName: 'عنوان صفحه',
  Id: 'آی دی',
  Title: 'عنوان',
  ParentId: 'پرنت آیدی',
  MappedTo: 'مپ شده با',
  OrgCat: 'دسته اصلی',
  Mapping: 'مپ کردن',
  MapCatDscrp:
    '   برای مپ کردن دسته بندی انتخاب شده با دسته بندی های وب سایت ، از لیست زیر دسته مورد نظر را انتخاب کنید و دکمه مپ کردن را فشار دهید.',
  walletPending:
    '  مبلغ در انتظار احراز هویت , پس از احراز هویت کارت بانکی به کیف پول کاربر افزوده و قابل استفاده خواهد بود.',
  CatSearch: 'جستجوی دسته بندی',
  CatSearchType: 'جستجو بر اساس نوع دسته بندی',
  Product: 'محصول',
  Cnt: 'تعداد',
  IsActive: 'فعال',
  DeActive: 'غیر فعال',
  Save: 'ذخیره',
  Close: 'بستن',
  Cancel: 'انصراف',
  Canceled: 'لغو شده',
  Canceleds: 'کنسلی ها',
  Status: 'وضعیت',
  ChangeStatus: 'تغییر وضعیت',
  ChangeProductStatus: 'تغییر وضعیت محصول',
  SubCat: 'زیر دسته',
  NotFound: 'موردی جهت نمایش وجود ندارد.',
  ShowAuthCardPic: 'نمایش تصویر احراز',
  UploadAuthCardPic: 'آپلود تصویر احراز',
  AuthCardPic: 'تصویر احراز',
  RejectList: 'لیست رد شده‌ها',
  Reason: 'علت',
  Modal: {
    Confirm: 'آیا از تأیید این نظر مطمئن هستید؟',
    Reject: 'آیا از رد کردن این نظر مطمئن هستید؟',
  },

  Action: {
    Answer: 'پاسخ',
    Confirm: 'تأیید',
    Reject: 'رد',
  },
  FakeUser: 'کاربر انارگیفت',
  StatusComment: {
    All: 'همه وضعیت‌ها',
    Pending: 'در انتظار تأیید',
    Approved: 'تأیید شده',
    Rejected: 'رد شده',
  },
  RejectBy: 'رد شده توسط',
  RejectDate: 'رد شده در تاریخ',
  BankwageMinPrice: 'کمترین کارمزد بانکی',
  BankwageMaxPrice: 'بیشترین کارمزد بانکی',
  Toman: 'تومان',
  Percent: 'درصد',
  Active: 'فعال',
  ticket: {
    title: 'عنوان',
    SendToApiGift: 'ارسال به تامین کننده',
    ApiGiftType: 'نوع ارسال',
    ApiGift: {
      Types: {
        Ruined: 'کد خراب',
        Repetitious: 'کد تکراری',
      },
    },
  },
  CheckFactorBtn: 'بررسی و ارسال فاکتور ها',
  DefinePattern: 'تعریف الگو',
  CreateCat: 'ایجاد دسته بندی',
  AddNewProduct: 'افزودن محصول جدید',
  AddNewStructure: 'افزودن ساختار جدید',
  FAQv2: 'سوالات متداول',
  AddNewGate: 'افزودن درگاه جدید',
  IncreaseWallet: 'افزایش موجودی کیف پول',
  AddNewOption: 'افزودن آپشن جدید',
  AddNewPage: 'افزودن صفحه جدید',
  AddNewVersion: 'افزودن نسخه جدید',
  AddNewRole: 'افرودن نقش جدید',
  AddNewPermission: 'افزودن مجوز جدید',
  AddPermission: 'افزودن مجوز ',
  AddBlackList: 'افزودن به بلاک لیست',
  GetBalance: 'دریافت آخرین موجودی',
  UpdateProduct: 'به روزرسانی محصولات',
  UpdateCategory: 'به روزرسانی دسته بندی ها',
  GetWalletBalance: 'دریافت آخرین موجودی کیف پول',
  PayListCheck: 'لیست خروجی تسویه حساب',
  AnarGift: 'انار گیفت',
  PageTitle: 'عنوان صفحه',
  CreateDate: 'تاریخ ایجاد',
  PutPageTitle: 'عنوان صفحه را وارد کنید.',
  VersionNumber: 'شماره نسخه را وارد کنید.',
  PermissionsList: 'لیست مجوز ها',
  DeletePageAlarm: 'آیا از حذف صفحه مطمئن هستید؟',
  SearchByRole: 'جستجو بر اساس عنوان مجوز',
  SearchByPage: 'جستجو بر اساس صفحه',
  Sorting: 'مرتب سازی',
  Permission: 'مجوز',
  PermissionTitle: 'عنوان مجوز',
  RelatedPage: 'مربوط به صفحه',
  CreatedAt: 'تاریخ ایجاد',
  UpdatedAt: 'تاریخ ویرایش',
  LastUsedAt: 'تاریخ آخرین استفاده',
  EnterPermissin: 'مجوز را وارد کنید.',
  EnterPermissionTitle: ' عنوان مجوز را وارد کنید.',
  PermissionsDelete: 'آیا از حذف مجوز مطمئن هستید؟',
  Page: 'صفحه',
  GroupTitle: 'عنوان گروه',
  Description: 'توضیحات',
  MetaDesc: 'متا توضیحات',
  NoDescription: 'بدون توضیحات',
  UsersList: 'لیست کاربران',
  AddUser: 'افزودن کاربر',
  EnterRole: 'عنوان نقش را وارد کنید.',
  RoleDelete: 'آیا از حذف نقش مطمئن هستید؟',
  SelectUser: 'انتخاب کاربر',
  SettingsTitle: 'تنظیمات',
  ActiveApi: 'api فعال سازی',
  NoBalanceMsg: 'ارسال پیامک اتمام موجودی',
  AutoReload: 'به روز رسانی خودکار',
  MinWalletBalance: 'حداقل موجودی کیف پول(واحد دلار)',
  WalletLastInfo: 'آخرین اطلاعات کیف پول',
  LastUpdateTime: 'آخرین تاریخ به روزرسانی',
  WalletBalance: 'موجودی کیف پول',
  WalletBalanceDet: 'موجودی کیف پول (با جزییات)',
  PendingBalance: 'موجودی کیف پول (با جزییات)',
  SelectStatus: 'انتخاب وضعیت',
  SeoTitle: 'عنوان سئو',
  rate: 'امتیاز',
  rateCount: 'تعداد امتیاز',
  SelectFlag: 'انتخاب پرچم کشور',
  BriefDescription: 'توضیحات کوتاه',
  CatDescription: 'توضیحات دسته بندی',
  CatType: 'نوع دسته بندی',
  SubCatDescription: 'توضیحات زیر دسته ',
  Notifications: 'نوتیفیکیشن',
  EducationalText: 'آموزش وارد کردن کد',
  UsageEducationalText: 'متن آموزش استفاده',
  Canonical: 'تگ کنونیکال',
  Robots: 'تگ robots',
  UnavailableHidden: 'مخفی در هنگام ناموجود',
  SubCatDelete: 'آیا از حذف زیر دسته مطمئن هستید؟',
  FinantialTransaction: 'تراکنش های مالی',
  SignedUpUserCnt: 'تعداد کاربران ثبت نامی',
  Person: 'نفر',
  UncompeletedGiftCard: 'لیست گیفت کارت های آماده نشده',
  NeedToBeCompeleted: 'نیاز به تکمیل شدن دارند.',
  NoProduct: 'محصولی وجود ندارد.',
  CodeNum: 'شماره کد',
  ManualBillsList: 'لیست فاکتور هایی که باید دستی ارسال شوند.',
  HoldCodes: 'لیست کدهای تعلیق شده',
  DuplicatedCodes: 'لیست کدهای  تکراری',
  SearchDuplicateCode: 'جستجوی تکراری بودن کد',
  NoFactor: 'فاکتوری وجود ندارد.',
  FactorNum: 'شماره فاکتور',
  ReplaceFrom: 'اختصاص کد از',
  SeeFactor: 'مشاهده فاکتور',
  WaitingToAuthList: 'لیست احرازهای در انتظار تایید',
  productsNotSendTitle: 'لیست خرید محصولات',
  NoProducts: 'لیستی خریدی وجود ندارد.',
  NoReqToSee: 'درخواستی جهت بررسی وجود ندارد.',
  NoUnreadTicket: 'تیکت خوانده نشده ای وجود ندارد',
  TicketNum: 'شماره تیکت',
  Ticket: 'تیکت',
  BillRejectReason: 'دلیل لغو فاکتور را وارد کنید',
  RejectBill: 'لغو فاکتور',
  ManualSubmit: 'ارسال دستی',
  BillSubmitCheck: 'آیا از ارسال محصولات این فاکتور اطمینان دارید؟',
  SearchByPermission: 'جستجو بر اساس عنوان مجوز',
  SendReplace: ' ارسال جایگزین ',
  SendReplaceDesc: 'یک عدد گیفت کارت از مخزن محصول به عنوان جایگزین ارسال خواهد شد',
  SendReplaceCount: 'تاکنون _count_ عدد جایگزین برای این کد ارسال شده است. آیا قصد دارید کد جایگزین جدیدی ارسال کنید؟',
  BuyPrice: 'قیمت خرید',
  BuyPriceUnit: 'قیمت خرید (قیمت واحد)',
  SendSms: 'ارسال پیامک',
  SendSmsDesc: 'بعد از تایید شما کد برای کاربر ارسال می گردد.',
  ShowCode: 'مشاهده کد',
  HoldCode: 'تعلیق کد',
  Block: ' بلاک ',
  unBlock: 'آزادسازی',
  ShowImg: 'مشاهده تصویر',
  BuyProductsInnerMap: 'محصولات خریداری شده (از محصولات مپ داخلی)',
  Sent: 'ارسال شده',
  DirectPurchase: 'خرید مستقیم',
  ManualDelivery: 'ارسال دستی',
  OtherDelivery: 'سایر',
  CustomerPurchase: 'خرید کاربر',
  CustomerPurchasedProducts: 'محصولات خریداری‌شده توسط کاربر',
  ConversionAndDelivery: 'تبدیل و ارسال',
  DeliveredToCustomer: 'تحویل به کاربر',
  DeliveredProductsDetails: 'جزئیات محصولات ارسال‌شده به کاربر',
  DeliveryMethod: 'روش ارسال',
  CountUnit: 'عدد',
  MappedFrom: 'از',
  TotalDelivered: 'جمع تحویل',
  PendingDelivery: 'در انتظار ارسال',
  DirectPurchaseAndDelivery: 'خرید و تحویل مستقیم',
  DirectPurchasedProductsDetails: 'جزئیات محصول خریداری‌شده و وضعیت تحویل آن',
  RequiredDeliveryCount: 'تعهد ارسال',
  PurchasedCount: 'خریداری‌شده',
  SentCount: 'ارسال‌شده',
  RemainingCount: 'باقی‌مانده',
  CanceledCount: 'کنسل‌شده',
  ReplacementStatus: 'جایگزین ارسال‌شده',
  NoReplacement: 'ندارد',
  MappingConversionReport: 'گزارش تبدیل محصولات مپ‌شده',
  ConvertedByMapping: 'تبدیل‌شده با مپ داخلی',
  MappingOutput: 'خروجی مپ',
  LegacyMappingOutputUnavailable: 'این محصول مپ شده است؛ جزئیات خروجی مپ در سوابق قدیمی ثبت نشده است.',
  TrackingCode: 'کد پیگیری',
  MappedProducts: 'محصولات مپ شده',
  UseInnerMap: 'استفاده از مپ داخلی ',
  SentUserInfo: 'اطلاعات ارسالی کاربر',
  BuyerInfo: 'مشخصات خریدار',
  BuyerName: 'نام خریدار',
  FactorDitails: 'جزيیات فاکتور',
  OrderDate: 'تاریخ سفارش',
  BankWage: 'کارمزد بانکی',
  Discount: 'تخفیف',
  DeliveryCost: 'هزینه ارسال',
  PayFromWallet: 'پرداخت از کیف پول',
  Tax: 'ارزش افزوده',
  WalletMaxCharge: 'حداکثر مبلغ مجاز شارژ کیف پول',
  Picture: 'تصویر',
  Replace: 'جایگزین',
  Autorization: 'احراز هویت',
  AllBills: 'همه فاکتور ها',
  NonAuthorized: 'احراز نشده',
  Processing: 'در حال پردازش',
  SearchByBillNum: 'جستجو بر اساس شماره فاکتور',
  SearchByCode: 'جستجو بر اساس شماره فاکتور تامین کننده',
  SearchByPhone: 'جستجو بر اساس شماره تلفن',
  SearchByCard: 'جستجو بر اساس شماره کارت',
  More: 'موارد بیشتر',
  ChangeBillStatus: 'تغییر وضعیت فاکتور',
  SmsSend: 'ارسال پیامکی',
  SendBill: 'ارسال فاکتور',
  CancelBill: 'لغو فاکتور',
  ShowProductCode: 'مشاهده کد محصولات',
  ShowUser: 'مشاهده کاربر',
  UserName: 'نام کاربر',
  BillCreated: 'تاریخ ثبت',
  BillTotalAmount: 'مبلغ کل فاکتور',
  NoNeed: 'بدون نیاز',
  Gate: 'درگاه',
  CryptoPay: 'پرداخت ارزی',
  CardNum: 'شماره کارت',
  Sender: 'ارسال کننده',
  PageSize: 'سایز صفحه',
  SendFactorConfirm: 'آیا از ارسال این فاکتور اطمینان دارید؟',
  System: 'سیستم',
  ReplaceCodeNumber: 'شماره کد',
  ProductName: 'نام محصول',
  BuyFrom: 'خرید از',
  BuyReport: 'گزارش خرید',
  Average: 'مبلغ میانگین',
  Amount: 'مبلغ',
  Dates: 'تاریخ ها',
  BuyDates: 'تاریخ های خرید',
  TotalAmount: 'مجموع مبلغ',
  SearchByProduct: 'جستجو بر اساس نام محصول',
  SearchByProductNum: 'جستجو بر اساس شماره محصول',
  DateTo: 'تا تاریخ',
  DateFrom: 'از تاریخ',
  BalanceReport: 'گزارش موجودی',
  TotalProfit: 'مجموع سود',
  AmountOverBillTotal: 'مجموع مبلغ اضافه بر فاکتور',
  AmountOverBill: ' مبلغ اضافه بر فاکتور',
  SearchByType: 'جستجو بر اساس نوع',
  SearchByWebhook: 'جستجو بر اساس نوع وب هوک',
  ProfitReport: 'گزارش سود',
  SellPrice: 'قیمت فروش',
  BillProfit: 'سود فاکتور',
  TotalLoss: 'مجموع ضرر',
  TotalLossDollar: 'مجموع ضرر به دلار',
  TotalBankWage: 'مجموع کارمزد بانک',
  TotalDiscount: 'مجموع تخفیف',
  TotalSell: 'مجموع فروش',
  ReplaceCodeReport: 'گزارش کد جایگزین',
  SellReport: 'گزارش فروش',
  AvgPrice: 'میانگین قیمت خرید',
  SendDate: 'تاریخ ارسال',
  SendBy: 'ارسال توسط',
  AvgPriceBuy: 'میانگین قیمت (دلار)  خرید',
  BankGate: 'درگاه بانکی',
  CryptoSellReport: 'گزارش فروش درگاه ارزی',
  TotalBuyDollar: 'مجموع خرید به دلار',
  TotalSellDollar: 'مجموع فروش به دلار',
  TotalBuyToman: 'مجموع خرید به تومان',
  TotalSellToman: 'مجموع فروش به تومان',
  Buy: 'خرید',
  Sell: 'فروش',
  Cortex: 'کارتکس',
  SelectCategory: 'انتخاب دسته بندی',
  Name: 'نام',
  TotalBuyAmount: 'مبلغ کل خرید',
  TotalSellAmount: 'مبلغ کل فروش',
  BeginCnt: 'تعداد در ابتدای بازه',
  EndCnt: 'تعداد در انتهای بازه',
  SearchByTransactionNum: 'جستجو بر اساس شماره تراکنش',
  SearchByTransactionType: 'جستجو بر اساس نوع تراکنش',
  SearchByPlatform: 'جستجو بر اساس پلتفرم',
  SearchByTransactionStatus: 'جستجو بر اساس وضعیت تراکنش',
  SelectGate: 'انتخاب درگاه',
  Transactions: 'تراکنش ها',
  TransactionNum: 'شماره تراکنش',
  GateTransactionNum: 'شماره تراکنش درگاه',
  FLName: 'نام و نام خانوادگی',
  TransactionType: 'نوع تراکنش',
  TransactionStatus: 'وضعیت تراکنش',
  TransactionGate: 'درگاه تراکنش',
  Platform: 'پلتفرم',
  TransactionAmount: 'مبلغ تراکنش',
  TransactionDate: 'تاریخ تراکنش',
  MaskedCard: 'کارت ماسک شده',
  Refid: 'refid',
  Variance: 'واریانس',
  CheckStatus: 'بررسی وضعیت',
  Type: 'نوع',
  WebhookType: 'نوع وب هوک',
  Operations: 'عملیات',
  ShowDatas: 'مشاهده داده ها',
  Component: 'کامپوننت',
  SearchByOperations: 'جستجو بر اساس عملیات',
  SearchByComponent: 'جستجو بر اساس کامپوننت',
  SearchByDiscount: 'جستجو بر اساس کد تخفیف',
  SearchByCount: 'جستجو بر اساس تعداد',
  SearchByStatus: 'جستجو بر اساس وضعیت',
  SearchByCompany: 'جستجو بر اساس شرکت',
  ManageDiscount: 'مدیریت تخفیف ها',
  CodeV2: 'کد',
  PricingType: 'نوع قیمت گذاری',
  Count: 'مقدار',
  DiscountFor: 'کد تخفیف مربوط به',
  UsedTimes: 'تعداد دفعات استفاده شده',
  ExpireDate: 'تاریخ انقضا',
  ShowDetails: 'مشاهده جزییات',
  DeleteRow: 'آیا از حذف سطر مطمئن هستید؟',
  PriceSetting: 'تنظیمات قیمت',
  DiscountAmount: 'مقدار تخفیف',
  DiscountPrice: 'مبلغ تخفیف',
  DiscountPriceMin: 'حداقل مبلغ تخفیف',
  DiscountPriceMax: 'حداکثر مبلغ تخفیف',
  PaySetting: 'تنظیمات پرداخت',
  PayType: 'نوع پرداخت',
  OnBillsMoreThan: 'اعمال بر فاکتور هایی با مبلغ بیش از',
  OtherSetting: 'سایر تنظیمات',
  CodeMaxUse: 'حداکثر تعداد استفاده از کد',
  FirstBuyUse: 'فعال برای اولین خرید',
  DiscountStatus: 'وضعیت کد تخفیف',
  CodeMethod: 'نحوه ساخت کد',
  EnterDiscount: 'کد تخفیف را وارد کنید',
  DiscountTo: 'اختصاص کد تخفیف به',
  SeeDetails: 'مشاهده جزییات',
  Exclusive: 'اختصاصی',
  DiscountManage: 'مدیریت تنظیمات کد تخفیف',
  CampainEndDate: 'تاریخ اتمام کمپین',
  DiscountDays: 'تعداد روز قابل استفاده بودن تخفیف',
  SendStatus: 'وضعیت ارسال',
  SellApi: 'فروش از api ',
  BuyApi: 'خرید از api ',
  PriceBelowBuyPrice: '  توجه. قیمت تمام شده برای این محصول از حداقل قیمت یا میانگین قیمت خرید کمتر است.',
  MinPrice: 'حداقل قیمت',
  FloatingFactor: 'ضریب شناور',
  duplicate_code: 'کد تکراری',
  BasePrice: 'قیمت پایه',
  AvgPricePerUnit: 'میانگین قیمت واحد',
  StaticFactor: 'ضریب ثابت',
  FinalPrice: 'قیمت نهایی',
  StatusWhenAvailable: '  وضعیت در هنگام موجود بودن',
  StatusWhenEmpty: 'وضعیت در هنگام نامجود بودن',
  StatusWhenDelay: 'وضعیت در هنگام ارسال با تاخیر',
  Exists: 'موجود',
  WaitingToRecieve: 'در انتظار دریافت',
  Sold: 'فروخته شده',
  SoldByMapp: 'فروخته شده با مپ داخلی',
  AddCode: 'افزودن کد',
  ReturnToProducts: 'بازگشت به محصولات',
  ReturnToFactor: 'بازگشت به فاکتور',
  SearchCodeInRepo: 'جستجوی کد در مخزن',
  SearchCodeId: 'جستجوی شماره کد',
  SearchApiFactor: 'جستجوی فاکتور خارجی',
  SearchInternalFactor: 'جستجوی فاکتور داخلی',
  Entrance: 'ورودی',
  PriceUnit: 'قیمت واحد',
  Rial: 'ریال',
  InnerFactor: 'فاکتور داخلی',
  ReadyToBuildCode: 'آماده ساخت کد',
  AddCodeToRepo: 'افزودن کد به مخزن',
  CreateNewCode: 'ساخت کد جدید',
  EnterDescriptionHiddenToUser: 'توضیحات مورد نظر را وارد کنید.این اطلاعات به کاربر نمایش داده نمی شود.',
  DeleteCodeFromRepo: 'آیا از حذف کد از مخزن مطمئن هستید؟',
  GiftCardInfoNotForUsers: '(اطلاعات زیر برای ایجاد گیفت کارت می باشد و نباید به مشتری تحویل داده شود.)',
  FactorInfo: 'اطلاعات فاکتور',
  CreatedBy: 'ساخته شده توسط',
  CreatedBy2: 'ایجاد شده توسط',
  ProductOrderNum: 'شماره سفارش محصول',
  EnterProductCnt: 'لطفا تعداد محصول مورد نظر خود را وارد کنید.',
  ProductEngName: 'نام انگلیسی محصول',
  Label: 'برچسب',
  LabelShow: 'برچسب نمایشی (نمایش در بخش پرداخت سریع)',
  dollarLabel: 'اعتبار دلاری(اگر اعتبار دلاری است وارد شود در غیر اینصورت خالی بگذارید.)',
  SelectSubCat: 'انتخاب زیر دسته',
  ProductTags: 'تگ های محصول',
  SelectCodeStructure: 'انتخاب ساختار کد',
  SelectDefualtPic: 'انتخاب عکس پیش فرض',
  InputValues: 'مقادیر ورودی',
  ExistStatus: 'وضعیت موجودی',
  SpecialSell: 'فروش ویژه',
  AddProductInputs: 'افزودن ورودی های محصول',
  AddField: 'افزودن فیلد',
  EnterInputField: 'عنوان فیلد ورودی را وارد کنید.',
  DeletePicAlert: 'آیا از حذف این عکس مطمین هستید؟',
  FeaturesOf: 'ویژگی های',
  Features: 'ویژگی ها',
  Unit: 'واحد',
  FeatureName: 'نام ویژگی',
  UnitStatus: 'وضعیت واحد',
  NoUnit: 'بدون واحد',
  OptionName: 'نام آپشن',
  AddMedia: 'افزودن محتوا',
  PricingOptions: 'آپشن های قیمت گذاری',
  AccessGiftSetting: 'تنظیمات دسترسی به گیفت کارت ها',
  Time: 'مدت زمان',
  DaysCnt: 'تعداد روز',
  ReqPerDay: '',
  Copy: 'کپی',
  Blocked: 'بلاک شده',
  Api: {
    Success: 'عملیات با موفقیت انجام شد',
    Error: 'خطایی رخ داده است',
  },
  Loading: 'در حال دریافت اطلاعات لطفا منتظر باشید.',
  SearchWith: 'جستجو بر اساس _name_',
  SortBy: {
    Oldest: 'قدیمی‌ترین‌ها',
    Newest: 'جدید‌ترین‌ها',
  },
  DeleteWarning: 'آیا از حذف این مورد مطمئن هستید؟',
  InternalMapping: 'مپ داخلی',
  ExternalMapping: 'مپ خارجی',
  CancelSend: 'لغو ارسال',
  AppendixImg: 'تصویر ضمیمه',
  Anardoni: 'اناردونی',
  Return: 'بازگشت',
  Nodata: 'داده ای موجود نیست',
  PaymentRateChart: 'نمودار رشد فروش',
  SupportDetails: 'توضیحات پشتیبان',
  Url: 'آدرس اینترنتی',
  Login_at: 'تاریخ ورود',
  Logout_at: 'تاریخ خروج',
  Browser: 'مرورگر',
  Device_type: 'نوع دستگاه',
  Os: 'سیستم عامل',
  CallInformation: 'اطلاعات تماس',
  Bill: 'فاکتور',
  Wallet: 'کیف پول',
  Accounts: 'حساب ها',
  statusInquiry: 'استعلام وضعیت',
  statusInquiryAll: 'استعلام وضعیت همه',
  Month: 'ماه',
  Day: 'روز',
  Hour: 'ساعت',
  Minute: 'دقیقه',
  Required: 'الزامی',
  PriceFrom: 'حداقل قیمت',
  PriceTo: 'حداکثر قیمت',
  PriceSelectType: 'نوع جستجو قیمت',
  ...users,
  ...Comments,
  ...Tickets,
  ...Payments,
  ...collections,
  ...LoginNotice,
  ...Bills,
  ...Settings,
  ...Reports,
  ...Packages,
  ...Logs,
  ...Dashboard,
  ...Support,
  ...Auth,
  ...TelegramBot,
  ...Categories,
  ...Products,
  ...bot,
  ...SiteBuilder,
  ...analyze,
}
